<template>
  <div class="items">
    <h1>Items</h1>
    <div v-if="items.length > 0" class="table-wrap">
      <div>
        <router-link v-bind:to="{ name: 'NewItem' }" class="">Add Item</router-link>
      </div>
      <table>
        <tr>
          <td>Item Name</td>
          <td align="center">Action</td>
        </tr>
        <tr v-for="(item, index) in items" :key="index">
          <td>{{ item.name }}</td>
          <td align="center">
            <router-link v-bind:to="{ name: 'EditItem', params: { id: item._id } }">Edit</router-link> |
            <a href="#" @click="deleteItem(item._id)">Delete</a>
          </td>
        </tr>
      </table>
    </div>
    <div v-else>
      There are no items.. Lets add one now <br /><br />
      <router-link v-bind:to="{ name: 'NewItem' }" class="add_item_link">Add Item</router-link>
    </div>
  </div>
</template>

<script>
import ItemService from '@/services/ItemService'
export default {
  name: 'items',
  data () {
    return {
      items: []
    }
  },
  mounted () {
    this.getItems()
  },
  methods: {
    async getItems () {
      const response = await ItemService.fetchItems()
      this.items = response.data.items
      console.log(this.items)
    },

    async deleteItem (id) {
      await ItemService.deleteItem(id)
      this.getItems()
      this.$router.push({ name: 'Items' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/items/Items.vue